import { brand } from '../../lib/brand';

/**
 * Pie discreto de la plataforma: tagline + copyright. El año es dinámico y el
 * nombre/tagline salen de `brand.ts` — no hardcodear ninguno.
 *
 * Se monta una sola vez en el shell (`Layout`), después del contenido de la sección.
 */
type BrandFooterProps = {
  className?: string;
};

export default function BrandFooter({ className }: BrandFooterProps) {
  const year = new Date().getFullYear();
  return (
    <footer
      className={['mt-10 pt-4 text-center', className].filter(Boolean).join(' ')}
    >
      <p className="text-sm font-medium text-ui-text-muted/80">{brand.tagline}</p>
      <p className="mt-0.5 text-sm text-ui-text-subtle/70">
        © {year} {brand.name}
      </p>
    </footer>
  );
}
